// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".background[data-v-5ed889b5]{background-repeat:no-repeat;background-size:auto 70vh;background-position-x:center;background-position-y:bottom}@media screen and (max-width:599px){#wrapper[data-v-5ed889b5]{padding:0 0 20px 0;margin-left:10px}}@media screen and (max-width:440px){#wrapper[data-v-5ed889b5]{padding:0 0 10px 0;margin-left:0}}", ""]);
// Exports
module.exports = exports;
